import { render, staticRenderFns } from "./tippingDocketDelete.vue?vue&type=template&id=94e708f4&"
import script from "./tippingDocketDelete.vue?vue&type=script&lang=js&"
export * from "./tippingDocketDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tippingDocketDelete.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {
  VBtn,
})
